export default __webpack_public_path__ + "static/media/7.43b82c28.png";